import React from 'react';
import Icon from '../../../components/AppIcon';

const NavigationGrid = ({ items, onNavigate }) => {
  const getColorClasses = (color) => {
    const colors = {
      blue: {
        bg: 'bg-blue-500/10',
        text: 'text-blue-500',
        hover: 'hover:bg-blue-500/20'
      },
      purple: {
        bg: 'bg-purple-500/10',
        text: 'text-purple-500',
        hover: 'hover:bg-purple-500/20'
      },
      green: {
        bg: 'bg-green-500/10',
        text: 'text-green-500',
        hover: 'hover:bg-green-500/20'
      },
      orange: {
        bg: 'bg-orange-500/10',
        text: 'text-orange-500',
        hover: 'hover:bg-orange-500/20'
      }
    };
    return colors?.[color] || colors?.blue;
  };

  return (
    <div className="mb-6">
      <h2 className="text-2xl font-semibold text-foreground mb-4">Quick Access</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {items?.map((item) => {
          const colors = getColorClasses(item?.color);
          return (
            <button
              key={item?.id}
              onClick={() => onNavigate(item?.route)}
              className={`bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all text-left ${colors?.hover}`}
            >
              <div className={`w-12 h-12 rounded-lg ${colors?.bg} flex items-center justify-center mb-4`}>
                <Icon name={item?.icon} size={24} className={colors?.text} />
              </div>
              <h3 className="text-base font-semibold text-foreground mb-2">{item?.title}</h3>
              <p className="text-sm text-muted-foreground mb-3 line-clamp-2">{item?.description}</p>
              {item?.badge && (
                <span className={`inline-block px-2 py-1 ${colors?.bg} ${colors?.text} text-xs font-medium rounded-full`}>
                  {item?.badge}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default NavigationGrid;